var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("label", { staticClass: "radio-input", class: _vm.classes }, [
    _c("input", {
      staticClass: "radio-input__input",
      attrs: {
        type: "radio",
        disabled: _vm.disabled,
        name: _vm.name,
        id: _vm.id,
        required: _vm.required
      },
      domProps: { value: _vm.value, checked: _vm.checked },
      on: { change: _vm.onChange, click: _vm.onClick }
    }),
    _c("span", { staticClass: "radio-input__radio-input" }),
    _vm.label
      ? _c("div", { staticClass: "radio-input__label-text" }, [
          _vm._v(_vm._s(_vm.label))
        ])
      : _c(
          "div",
          { staticClass: "radio-input__label-text" },
          [_vm._t("default")],
          2
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }